<template>
  <v-alert
    :type="pago ? 'success' : 'warning'"
    :value="locacao_fechada"
    border="left"
    text
    outlined
    prominent
  >
    <v-row align="center" dense>
      <v-col class="grow">
        {{
          pago
            ? "Pagamento efetuado. Total pago: " + formatMoney(total_pago)
            : "Pagamento pendente"
        }}
      </v-col>
      <v-col class="shrink">
        <v-btn
          v-if="!pago"
          @click="$refs.marcar_como_pago.open({ total_pago: total })"
          color="warning"
          dark
        >
          <v-icon>mdi-check</v-icon>
          Pagar
        </v-btn>
        <ServerButton
          v-else
          :action="() => api.locacoes.marcarComoNaoPago(this.locacao_codigo)"
          @executed="handleExecuted"
          icon
        >
          <v-icon left>mdi-keyboard-return</v-icon>
        </ServerButton>
      </v-col>
    </v-row>
    <MarcarComoPagoDialog
      ref="marcar_como_pago"
      :locacao_codigo="locacao_codigo"
      @pago="handleExecuted"
    />
  </v-alert>
</template>

<script>
import ServerButton from "../../server/ServerButton.vue";
import MarcarComoPagoDialog from "./MarcarComoPagoDialog.vue";
import api from "@/services/locacoes.js";
import MoneyMixin from "@/mixins/MoneyMixin.js";

export default {
  mixins: [MoneyMixin],

  components: {
    ServerButton,
    MarcarComoPagoDialog
  },

  props: {
    pago: Boolean,
    total_pago: Number,
    total: Number,
    locacao_codigo: String,
    locacao_fechada: Boolean
  },

  data() {
    return {
      loading: false,
      api
    };
  },

  methods: {
    handleExecuted(response) {
      this.$emit("changed", response);
    }
  },

  computed: {}
};
</script>
